import { createTheme } from '@mui/material/styles';
import type {} from '@mui/x-tree-view/themeAugmentation';

import MuiAlert from './MUIAlert';
import MuiBreadcrumbs from './MUIBreadCrumbs';
import MuiButton from './MUIButton';
import MuiChip from './MUIChip';
import MuiDialogActions from './MuiDialogActions';
import MuiDialogContent from './MUIDialogContent';
import MuiDialogContentText from './MUIDialogContentText';
import MuiDialogTitle from './MUIDialogTitle';
import MuiDivider from './MUIDivider';
import MuiTable from './MUITable';
import MuiTooltip from './MUITooltip';
import MuiTypography from './MUITypography';
import getPalette from './palette';
import typography from './typography';

const theme = createTheme({
  typography,
  components: {
    MuiTooltip,
    MuiButton,
    MuiTable,
    MuiChip,
    MuiBreadcrumbs,
    MuiAlert,
    MuiTypography,
    MuiDivider,
    MuiDialogTitle,
    MuiDialogContent,
    MuiDialogContentText,
    MuiDialogActions,
  },
});

const MUITheme = createTheme(theme as unknown, {
  palette: {
    ...getPalette(theme),
  },
});

export default MUITheme;
